// extracted by mini-css-extract-plugin
export default {"button":"Clock_button__+VeB0","clock":"Clock_clock__xpAQz"};